// ─────────────────────────────────────────────────────────────
// sentry.identity.ts
//
// Sets / clears the Sentry user so every event is attributed to the
// logged-in user (the Sentry dashboard then groups & filters issues by
// user). Called at both login sites (App.tsx rehydrate, Sign.tsx
// interactive) and cleared on logout (ProfileCard manual + forced-401
// in the store).
// ─────────────────────────────────────────────────────────────

import * as Sentry from "@sentry/react";
import { SentryUserInput } from "./sentry.types";

/** Attach the logged-in user + tenant/role tags to all subsequent events. */
export const setSentryUser = (userData: SentryUserInput): void => {
  Sentry.setUser({
    id: userData?.user_id,
    email: userData?.email,
    username: userData?.name,
  });
  if (userData?.org_id) {
    Sentry.setTag("client_code", userData.org_id);
  }
  if (userData?.role) {
    Sentry.setTag("user_role", userData.role);
  }
};

/** Detach the user + tenant/role tags on logout so events aren't misattributed. */
export const clearSentryUser = (): void => {
  Sentry.setUser(null);
  Sentry.setTag("client_code", undefined);
  Sentry.setTag("user_role", undefined);
};
